<script setup lang="ts">
  const contentDisplaySettingsStore = useContentDisplaySettingsStore()
  await contentDisplaySettingsStore.initialized
  const { featureFlags } = storeToRefs(contentDisplaySettingsStore)
  const marketplaceShortcuts = useMarketplaceShortcuts(
    {
      affinity: (tilesCount: number) =>
        useAffinityTiles({
          pubKey: 'dtj58',
          tagId: 52237,
          domainName: 'onenews.com',
          tilesCount,
        }),
      admarketplace: () => useAdMarketTile(),
    },
    featureFlags.value
  )

  const provider = marketplaceShortcuts.provider
  const shortcuts = marketplaceShortcuts.shortcuts
  const isShortcutsLoading = marketplaceShortcuts.isShortcutsLoading
</script>

<template>
  <ClientOnly>
    <LayoutsHome
      :marketplace-shortcuts="shortcuts"
      :marketplace-shortcuts-provider="provider"
      :is-shortcuts-loading="isShortcutsLoading"
    />
  </ClientOnly>
</template>
